import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';
import NextInstallment from '../nextInstallment/nextInstallment';
import PastDue from '../pastDue/pastDue';

import React from 'react';
import {useTranslation} from 'react-i18next';
import './AccountSummary.css';
import {connect} from 'react-redux';

const AccountSummary = (props) => {
  const {t} = useTranslation();
  return (
    <div className="account-summary-container">
      <div className="account-summary-title">{t('ACCOUNT_SUMMARY')}</div>
      <PastDue />
      {props.paymentScheduleLoader ? (
        <SkeletonLoader componentName="nextInstallment" />
      ) : (
        props.nextInstallment &&
        Object.keys(props.nextInstallment).length !== 0 && <NextInstallment />
      )}
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    paymentScheduleLoader: state.appStates.paymentScheduleLoader,
    nextInstallment:
      state.appStates.paymentSchedule?.paymentSchedules?.nextInstallment,
  };
};
export default connect(mapStateToProps)(AccountSummary);
